import Vue from 'vue'
import App from './App'

import Api from '@/plugin/api'
import router from './router'
import decryption from '@/plugin/decryption'
import {
store
} from './store/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)





import { Dialog, List, Picker, Field, Popup } from 'vant'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Vue.config.productionTip = false

Vue.use(Api)
Vue.use(decryption)

Vue.use(ViewUI)
Vue.use(Dialog).use(List).use(Picker).use(Field).use(Popup)

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store: store,
components: {
App
},
template: '<App/>'
})
router.beforeEach((to, from, next) => {
if (to.meta.title) {
document.title = to.meta.title
}
next()
})
Vue.directive('vmax', {
update: function (el, {
value,
modifiers
}, vnode) {
try {
let max = 0
if (value) {
max = Number(value)
}
if (Number(el.value) > max) {
el.value = max
}
if (Number(el.value) < 0) {
el.value = 0
}
modifiers.lazy ? el.dispatchEvent(new Event('change')) : el.dispatchEvent(new Event('input'))
} catch (e) { }
},
inserted: function (el, {
value,
modifiers
}, vnode) {
try {
console.log('------------------1')
console.log(value)
let max = 0
if (value) {
max = Number(value)
}
if (Number(el.value) > max) {
el.value = max
}
if (Number(el.value) < 0) {
el.value = 0
}
modifiers.lazy ? el.dispatchEvent(new Event('change')) : el.dispatchEvent(new Event('input'))
} catch (e) { }
}
})


// WEBPACK FOOTER //
// ./src/main.js